// import React from "react";
// import AntTable from "components/common/Table/AntTable";
// import PropTypes from "prop-types";
// import AttendanceTable from "../../../../../components/common/Table/AntTableTest";

// @autobind
// export default class ReportTable extends React.PureComponent {
//   static propTypes = {
//     columns: PropTypes.array,
//     dataSource: PropTypes.array,
//     properties: PropTypes.object,
//     loading: PropTypes.bool,
//     title: PropTypes.string,
//     reportBuilder: PropTypes.bool,
//   };
//   static defaultProps = {
//     reportBuilder: false,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {};
//     this.attendanceTableRef = null;
//   }
  
//   // متد برای ذخیره رفرنس به کامپوننت AttendanceTable
//   setAttendanceTableRef = (ref) => {
//     this.attendanceTableRef = ref;
//   }
  
//   // متد عمومی برای صدور فایل اکسل که می‌تواند از بیرون فراخوانی شود
//   exportToExcel = () => {
//     if (this.attendanceTableRef) {
//       this.attendanceTableRef.exportToExcel();
//     }
//   }

//   _DataSource(dataSource) {
//     let data = [];
//     dataSource.map((array) => {
//       if (!app._.isEmpty(array.body)) {
//         data.push(...array.body);
//       }
//     });
//     return data;
//   }

//   _Footer(dataSource) {
//     return dataSource[0]?.footerItems;
//   }

//   render() {
//     const {
//       columns,
//       dataSource,
//       properties,
//       title,
//       loading,
//       reportBuilder,
//       report,
//     } = this.props;
//     let _dataSource = this._DataSource(dataSource);
//     let _Footer = this._Footer(dataSource);

//     console.log("datadataSourceSourcedataSource", dataSource);
//     return (
//       <AttendanceTable
//         data={dataSource}
//         autoExport={false} // خروجی خودکار را غیرفعال می‌کنیم تا فقط با دکمه فعال شود
//         exportTitle={title || "گزارش حضور و غیاب"}
//         loading={loading}
//         properties={properties}
//         onRef={this.setAttendanceTableRef}
//       />
//     );
//   }
// }


import React from "react";
import AntTable from "components/common/Table/AntTable";
import PropTypes from "prop-types";

@autobind
export default class ReportTable extends React.PureComponent {
  static propTypes = {
    columns: PropTypes.array,
    dataSource: PropTypes.array,
    properties: PropTypes.object,
    loading: PropTypes.bool,
    title: PropTypes.string,
    reportBuilder: PropTypes.bool,
  };
  static defaultProps = {
    reportBuilder: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  _DataSource(dataSource) {
    let data = [];
    dataSource.map((array) => {
      if (!app._.isEmpty(array.body)) {
        data.push(...array.body);
      }
    });
    return data;
  }

  _Footer(dataSource) {
    return dataSource[0]?.footerItems;
  }

  render() {
    const {
      columns,
      dataSource,
      properties,
      title,
      loading,
      reportBuilder,
      report,
    } = this.props;
    let _dataSource = this._DataSource(dataSource);
    let _Footer = this._Footer(dataSource);

    console.log("datadataSourceSourcedataSource", dataSource);
    return (
      <AntTable
        Footer={_Footer}
        reportBuilder={reportBuilder}
        loading={loading}
        columns={columns}
        dataSource={_dataSource}
        dataPrint={dataSource}
        dataExport={_dataSource}
        printTitle={title}
        rowKey="key"
        jsPagination={true}
        jsSort={true}
        jsFilter={true}
        rowSelection={false}
        haveSetting={true}
        haveExport={true}
        havePrint={true}
        haveCustomExport={true}
        haveCustomPrint={true}
        properties={properties}
        pagination={false}
        report={report}
      />
    );
  }
}
